import React, { useEffect } from 'react';
import VideoService from '../service/VideoService';

export default function useIsAssignmentsRead({ storyId, assignments, user, updateAssignments }) {
  const sendAssignmentRead = async () => {
    await VideoService.readAssignments(storyId);
    const assignments = await VideoService.getVideoAssignmentsList(storyId);
    updateAssignments(assignments);
  };

  useEffect(() => {
    if (user && storyId) {
      const userAssignments = assignments.filter(item => item.assigned?.username === user.username);
      if (userAssignments.length > 0) {
        const isNotRead = userAssignments.some(item => item.readAt === null);
        isNotRead && sendAssignmentRead();
      }
    }
  }, [assignments, user]);
}
